// @flow
import React, { type Node } from 'react';


/**
 * Необязательный в структуре таблицы компонент.
 * Выделяет секцию со строками таблицы (Row), для того
 * чтоб работал :first-child в стилях первого элемента Row.
 * Обязательно использовать для разворачивающихся строк таблицы. (details)
 */

type Props = {
  children: Node,
}

const Body = ({ children }: Props) => <div>{children}</div>;

export default Body;
